import {combineReducers} from 'redux';
import Definition from 'routes/Home/Attendance/Forgiveness/Definition/Module';
import Assignment from 'routes/Home/Attendance/Forgiveness/Assignment/Module';

const reducers = combineReducers({
  Definition,
  Assignment,
});

export default reducers;
